import { useSelector } from 'react-redux';

export const useCurrentOrderStudentId = () => {
  const selectedStudentId = useSelector(
    (state) => state.additionalData.selectedStudent?.id,
  );

  const shootEventId = useSelector((state) => {
    const s = state.shoot.shoot;
    return s?.event_id || s?.id;
  });

  const orderKey =
    shootEventId && selectedStudentId
      ? `${shootEventId}-${selectedStudentId}`
      : null;

  const order = useSelector((state) =>
    orderKey ? state.v3Order.orders[orderKey] : undefined,
  );

  if (order && orderKey) {
    return orderKey;
  }

  return null;
};
